import type { FaireProductEntity } from "../../entity_types/product";

export const p_n8eee6n2qd: FaireProductEntity = {
  token: "p_n8eee6n2qd",
  type: "product",
  name: "Colored Enamel Index Finger Ring in 925 Sterling Silver",
  brandToken: "b_xd955m9fpf",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/8719dc38da98ac71a456cebea5a83a7dba5dc7ea64fe42446a3915aeafd2e1f7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/48ddd48f4ebc0f826cc32025eb5ff6f712a9e3e631a2cd7664678e8aa7b210ef.png",
    "https://cdn.faire.com/fastly/33bd7469a5900c0e0378bed6b28c8217c9562a1cc155fa92393516b4c1c77026.jpeg",
    "https://cdn.faire.com/fastly/7da5398514dc2f7b20f893e008147236f67eca65d89bf1ad6bcf2fd5a3d9e27d.png",
    "https://cdn.faire.com/fastly/be8d1e8b8c7b20d7f189b62658dd9862422f0b422e0352cc1115968b4f0b3375.jpeg",
    "https://cdn.faire.com/fastly/907e2bf6e072e5d9821ee7bdcdc2e289e0d097e07e0e79369248954981ecd27f.png",
    "https://cdn.faire.com/fastly/a534ddf32161d1d46dccee357bf0e9e78a4b538d081ac60b0405420d1de1fd55.jpeg",
    "https://cdn.faire.com/fastly/2ae30f9952accaf01090f0a4476e07308096866383fac48d12dec0698a9b40be.png",
    "https://cdn.faire.com/fastly/563228d74be84af63f1361ff44ae1ced0dd95dde8c51d31c77fb0103a195d87d.jpeg",
    "https://cdn.faire.com/fastly/32d8e756f55c97465650776b3e41232ebe440d8667e617cafc5bee2def3ec555.png",
  ],
  priceDollars: 11.5,
  description:
    "Description & Details\n\nThe dripping process makes the surface of the entire ring look very smooth, and a sense of high quality also follows. Put on this ring and put on your elegant clothes, which is full of personality.\n\n * Solid 925 sterling silver, enamel \n * hypoallergenic, gold plating \n * 17 mm diameter\n * US size adjustable ",
  tags: [],
  msrpDollars: 23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:07.511Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
